const headerCollapse = (): void => {
  const collapseHeaderContainer = document.getElementById('collapse-header');
  if (!collapseHeaderContainer) return;

  const collapseHeaderBtn =
    collapseHeaderContainer.querySelector<HTMLButtonElement>(
      '.collapse-header__btn',
    );
  if (!collapseHeaderBtn) return;

  const collapseHeader = (): void => {
    const isCollapsed =
      collapseHeaderContainer.getAttribute('data-collapsed') === 'true';
    collapseHeaderContainer.setAttribute(
      'data-collapsed',
      (!isCollapsed).toString(),
    );
    collapseHeaderBtn.textContent = isCollapsed ? 'Read less' : 'Read more';
  };

  collapseHeaderBtn.addEventListener('click', collapseHeader);
};

export default headerCollapse;
